// 请保证所有语言包 的Key值都一直
export default {
  login: {
    username: 'Kullanıcı adı',
    password: 'Şifre'
  },
  menu: {
    Menu_ItemList: 'Proje Listesi',
    Menu_ToDoList: 'Yapılacaklar Listesi',
    Menu_Drafts: 'Taslak'
  },
  common: {
    welcome: 'Hoşgeldiniz',
    upload: 'Yükle',
    download: 'İndir',
    save: 'Kaydet',
    saveDraft: 'Taslağı Kaydet',
    submit: 'Gönder',
    view: 'Görünüm',
    delete: 'Sil',
    edit: 'Düzenle',
    search: 'Sorgu',
    reset: 'Sıfırlama',
    export: 'Dışa Aktar',
    discard: 'İptal Et',
    audit: 'Onay',
    preReturnBtn: 'Dönüş',
    uploadtip: 'Max 30M'
  },
  message: {
    unbound: 'Hesabınız geçerli bir ortaklık sözleşmesine bağlı DEĞİLDİR. Lütfen ortaklık sözleşmesinin hala aktif olduğundan ve hesabın bağlandığından emin olun. Herhangi bir sorunuz varsa, lütfen Ruijie Satış departmanı ile iletişime geçin.',
    prompt: 'Lütfen en azından iki karakter girin.',
    registrationNo: "Kayıt Hayır'a girin.",
    hints: 'Eğer  proje düşürülmüşse veya  proje  korunması gerekmiyorsa, atılacak projeye tıklayın.',
    deleteConfirm: 'Silmek istediğinize emin misiniz?',
    discardConfirm: 'İptal etmek istediğinize emin misiniz?',
    cancel: 'İptal',
    comfirm: 'Onayla',
    deletesuccess: 'Silme Başarısı',
    setDepartment: 'Lütfen departmanı ayarlamak için yöneticiye bağlantı edin.',
    operation: 'Operasyon',
    queryResult: 'Sorgulama sonuçları',
    needPartnerName: 'Lütfen bir ortak adı girin',
    needProjectName: 'Lütfen bir proje adı girin',
    needRuijieSaleName1: 'Lütfen Ruijie satış temsilcisini girin',
    needCountry: 'Lütfen projenin ülkesini girin',
    needFinalCompanyName: 'Lütfen son kullanıcı şirket adını girin',
    needFinalCompanyAddress: 'Lütfen son kullanıcı şirket adresini giriniz',
    needFinalUserName: 'Lütfen son kullanıcı proje yöneticisini girin',
    needFinalUserPosition: 'Lütfen son kullanıcı proje yöneticisinin üvanını girin',
    needFinalUserTel: 'Lütfen son kullanıcı proje yöneticisinin telefon numarasını girin',
    needFinalUserEmail: 'Lütfen son kullanıcı proje yöneticisinin e-postasını girin',
    needFundsInPlace: 'Lütfen fonların yerinde olup olmadığını seçin',
    needProjectBudget: 'Lütfen genel proje bütçesini girin',
    needNetworkBudget: 'Lütfen proje bütçesini girin',
    needPurchaseTime: 'Lütfen satın alma zamanını girin',
    needExpectedOrderDate: 'Lütfen beklenen sipariş zamanını seçin',
    needIsSupportRuijie: 'Lütfen son kullanıcı proje liderinin Ruijie\'yi destekleyip desteklemediğini seçin',
    needHasCooperated: 'Lütfen daha önce işbirliği yapıp yapmadığınızı seçin',
    needRuijieSaleName: 'Lütfen Ruijie satış temsilcisini girin',
    needProjectRequirements: 'Lütfen proje isterlerini girin',
    needEmail: 'Lütfen bir e-posta girin',
    needBeEmail: 'Lütfen doğru e-posta biçimini girin',
    needPartnerEmail: 'Lütfen iş ortağınızın e-posta adresini girin',
    needPartnerContactName: 'Lütfen iş ortağınızın adını girin',
    needPartnerPhone: 'Lütfen iş ortağınızın telefonuna girin',
    needJointVisit: 'Lütfen ortak bir ziyaret düzenleyip düzenleyemeyeceğinizi seçin',
    needProjectPhase: 'Lütfen bir proje aşaması seçin',
    unitOfCash: 'USD',
    saveSuccess: 'Başarıyla kaydet',
    submitSuccess: 'Başarıyla Gönder',
    submitError: 'Gönderme başarısız oldu',
    select: 'Lütfen seçin',
    agree: 'Kabul et',
    reject: 'Reddet',
    rejectToFirst: 'İlk adımı reddet',
    needOpinion: 'Lütfen gözden geçirmek için bir neden girin',
    needDiscardReason: 'Lütfen iptal etmek için bir neden girin',
    discardSuccess: 'Başarıyı iptal et',
    clause: 'Raporlama Şartları',
    close: 'Kapat',
    readAndAgree: 'Ruijie International Partner Program Koruma Koşullarını okudum ve kabul ediyorum.',
    pleaseReadAndAgreeClause: 'Lütfen Ruijie Uluslararası Ortak Programı Koruma Şartlarını okuyup kabul edin.',
    budgetMaxValue: 'Bütçe 12 haneyi geçmemelidir',
    budgetNotAllow: 'Lütfen 12 basamak içinde pozitif bir sayı girin',
    budgetCantNegative: 'Bütçe tutarı negatif olamaz',
    needNumberType: 'Lütfen sayı türünü girin',
    enterProjectName: 'Sorgu için proje adını girin',
    enterFinalUserName: 'Sorgu için son kullanıcı adını girin',
    enterFinalCompanyAddress: 'Soru için proje uygulama adresini girin',
    approver: 'Itirafçı',
    logout: 'Oturumu kapat'
  },
  page: {
    drafts: 'Taslak',
    addProject: 'Yeni Proje',
    list: 'Proje Listesi',
    todoList: 'Yapılacaklar Listesi',
    projectSearch: 'Kayıtlı Proje Arama',
    prmNew: {
      title: 'Yeni Proje',
      partnerName: 'Ortak Adı',
      projectName: 'Proje Adı',
      country: 'Proje Ülkesi',
      finalCompanyName: 'Son Kullanıcı Şirketi İsmi',
      finalCompanyAddress: 'İşlenme projesi adresi',
      finalUserName: 'Son Kullanıcı Proje Yöneticisi',
      finalUserPosition: 'Son Kullanıcı Proje Yöneticisi Unvanı',
      finalUserTel: 'Son Kullanıcı Proje Yöneticisi  Telefonu',
      finalUserPhone: 'Son Kullanıcı Proje Yöneticisi cep telefonu numarası',
      finalUserEmail: 'Son Kullanıcı Proje Yöneticisi E-Posta',
      fundsInPlace: 'Fonların yerinde olup olmadığı?',
      projectBudget: 'Proje Genel Bütçesi',
      networkBudget: 'Proje Bütçesi',
      expectedOrderDate: 'Beklenen sipariş süresi',
      isSupportRuijie: 'Son Kullanıcı Proje Yöneticisi Ruijie yi destekliyor mu?',
      ruijieSaleName: 'Lütfen Ruijie satış temsilcisini girin',
      hasCooperated: 'Daha önce işbirliği yaptınız mı?',
      projectPhase: 'Bu projenin hangi adımı',
      projectPhases: 'Bu projenin hangi adımı',
      expctedOrderDate: 'expcted order date',
      lastUpdata: 'son güncellemessage status',
      projectRequirements: 'Kullanıcı proje gereksinimleri',
      budgetFrom: 'Bütçe Kaynağı?',
      executiveDepartment: 'Bu projeye hangi departman başladı veya başlayacak?',
      participatingDepartment: 'Bu projeye hangi bölüm katılıyor veya katılacak?',
      dockingPeople: 'Danışmanımız ya da destekçimiz kim olabilir ve hangi unvanı?',
      competitorSituation: 'Rakip Durumu',
      beforeSell: 'Bu son kullanıcıya daha önce hangi ürünleri sattın?',
      projectAttachment: 'Bu projenin üretim Bom listesi',
      projectAttachmentDetail: 'Proje yapılandırma listesi',
      partnerEmail: 'Ortak Kayıdı İletişim E-postası',
      partnerContactName: 'Partner Registration İletişim Adı',
      partnerPhone: 'Ortak kaydı iletişim telefonu',
      projectContractor: 'Proje Yüklenicisi (Zayıf Akım Projesi)',
      relatedRAP: 'İlişkili RAP',
      jointVisit: 'Ortak ziyaret düzenleyebilir miyim?',
      fillFullName: 'Tam adı doldurmanız gerekir'
    },
    prmList: {
      projectStep: 'proje adımı',
      registration: 'kayıt',
      partnerName: 'Ortak Adı',
      projectName: 'Proje Adı',
      country: 'Proje Ülkesi',
      ruijieSaleName: 'Satış Temsilcisi',
      taxNumber: 'Vergi Numarası',
      approvalState: 'Onay düğümü',
      prmState: 'Durum',
      discardReason: 'Nedeni Kaldır',
      // showClause: 'Kayıt bildirim şartlarını görüntüle',
      showClauseSBG: 'SBG raporunun talimatlarını görüntüle',
      showClauseEBG: 'EBG raporunun talimatlarını görüntüle',
      applicant: 'Başvuru sahibi',
      submitTime: 'Zamanı Gönder'
    },
    prmDetail: {
      contentTitle: 'Proje Bilgisi',
      approvalTitle: 'Onay Kaydı',
      approvalNode: 'Onay düğümü',
      operator: 'Operatör',
      auditStatus: 'Durum',
      approvalDate: 'Onay süresi',
      approvalRemarks: 'Onay Talimatları',
      operatorLogTitle: 'İşlem Günlüğü',
      operation: 'İşlem İçeriği',
      fieldName: 'alan adı',
      oldValue: 'Old Value',
      newValue: 'Yeni Değer',
      updateTime: 'Güncelleme Zamanı',
      operationType: 'İşlem Türü',
      endUserInfo: 'Kullanıcı Bilgisini Bitir',
      partnerInfo: 'Ortak Bilgisi'
    },
    prmEdit: {
      title: 'Düzenle'
    },
    prmAudit: {
      title: 'Onay',
      remarksApproval: 'Onay Talimatları'
    },
    prmView: {
      title: 'Sorgu'
    },
    ProjectSearch: {
      result: 'Result',
      country: 'Ülke/Bölge',
      sales: 'Satış',
      email: 'E-posta'
    }
  }
};
